import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=f4644d98&scoped=true&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-manage.css?vue&type=style&index=0&id=f4644d98&scoped=true&lang=css&"
import style1 from "./Material.vue?vue&type=style&index=1&id=f4644d98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4644d98",
  null
  
)

export default component.exports